import validate from "/codebuild/output/src1692386816/src/melembre-landing-page-v2/node_modules/nuxt/dist/pages/runtime/validate.js";
import route_45watcher_45global from "/codebuild/output/src1692386816/src/melembre-landing-page-v2/middleware/routeWatcher.global.ts";
import manifest_45route_45rule from "/codebuild/output/src1692386816/src/melembre-landing-page-v2/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  route_45watcher_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}